import { AuthenticatedApiError, postAuthenticatedApi } from './postAuthenticatedApi';

export interface InitiateOpenEnrollForAAAResult {
  membershipNumber?: string;
  promotionCode: string;
  promotionRef: string;
  promotionType: string;
  success: boolean;
}

export interface RegisterRetailUserAddressInput {
  addressLine1?: string | null;
  addressLine2?: string | null;
  administrativeArea?: string | null;
  countryCode?: string | null;
  locality?: string | null;
  postalCode?: string | null;
}

export interface RegisterRetailUserInput {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  password?: string | null;
  firebaseId?: string | null;
  address?: RegisterRetailUserAddressInput | null;
  planIds?: string[] | null;
  termsAccepted?: boolean | null;
}

export interface RegisterRetailUserResult {
  node?: {
    id?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    status?: string;
  } | null;
}

export class EnrollmentClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EnrollmentClientError';
  }
}

/**
 * Phoenix retail user was created, but promo redeem failed.
 * Keep the Firebase session so the user is not orphaned from their Phoenix account.
 */
export class RedeemAfterRegisterError extends Error {
  constructor(cause: unknown) {
    const message = cause instanceof Error ? cause.message : 'Unable to redeem promotion code, please try again.';
    super(message);
    this.name = 'RedeemAfterRegisterError';
  }
}

async function postEnrollmentApi<T>(path: string, body: unknown): Promise<T> {
  try {
    return await postAuthenticatedApi<T>(path, body);
  } catch (error) {
    if (error instanceof AuthenticatedApiError) {
      throw new EnrollmentClientError(error.message);
    }
    throw error;
  }
}

export async function initiateOpenEnrollForAAARequest(input: {
  membershipNumber: string;
  promotionRef: string;
}): Promise<InitiateOpenEnrollForAAAResult> {
  const data = await postEnrollmentApi<{ initiateOpenEnrollForAAA: InitiateOpenEnrollForAAAResult }>(
    '/api/enrollment/initiate-aaa',
    input,
  );
  return data.initiateOpenEnrollForAAA;
}

export async function registerRetailUserRequest(input: RegisterRetailUserInput): Promise<RegisterRetailUserResult> {
  const data = await postEnrollmentApi<{ registerRetailUser: RegisterRetailUserResult }>(
    '/api/enrollment/register-retail-user',
    { input },
  );
  return data.registerRetailUser;
}
